import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-alert-generico',
    templateUrl: './alert-generico.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class AlertGenericoComponent {

  @Input() buttons: Array<{
    action: (event: MouseEvent) => any,
    className?: string,
    text: string,
  }> = [];
  @Input() description = '';
  @Input() message = '';
  @Input() show: boolean = false;
  @Input() icon: string = '';
  @Input() type: 'success' | 'danger' | 'warning' = 'success';

  public get iconPath() : string {
    const pathPrefix = '/assets/img/'
    if (this.icon) {
      const isAbsolutePath = this.icon.includes('/')
      if (isAbsolutePath) {
        return this.icon
      }
      return `${pathPrefix}${this.icon}`
    }
    const iconName = this.getIconName(this.type)
    return `${pathPrefix}${iconName}`
  }

  public get textColor(): string {
    if (this.type === 'warning') {
      return '';
    }
    return `text-${this.type}`
  }

  public get bgColor(): string {
    if (this.type === 'warning') {
      return ''
    }
    return `bg-${this.type}`
  }

  constructor() { }

  private getIconName(type) {
    switch (type) {
      case 'danger':
        return `error.png`;
      case 'warning':
        return `inconsistencia.png`;
      case 'success':
      default:
        return `success.png`;
    }
  }

}
